<template>
  <p-vue-button
    class="plus-button p-button-rounded p-button-success"
    :class="{ withText: text ? true : false }"
  >
    <label class="p-mx-1" v-if="text">+ {{ text }}</label>
    <i-icon v-else name="plus" />
  </p-vue-button>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: null,
    },
  },
};
</script>

<style scoped>
.plus-button {
  right: 15px;
  bottom: 15px;
  position: absolute;

  align-items: center;
  justify-content: center;

  width: 42px;
  height: 42px;

  padding: 0;

  border: 2px solid white !important;
  box-shadow: 0px 3px 7px 0 rgba(0, 0, 0, 0.35);
}

.plus-button.withText {
  width: auto;
  padding-right: 7px;
  padding-left: 5px;
}

.plus-button:deep(.svg) {
  width: 20px;
  height: 20px;
}
</style>
